import {useIntl} from "react-intl";
import {CommonUnitMessages} from "../../../intl/commonMessages/CommonUnitMessages";

export const DisplayFlyDuration = (hours: number, minutes: number): string => {
  const intl = useIntl();

  return `${hours} ${intl.formatMessage(CommonUnitMessages.hour)} ${minutes} ${intl.formatMessage(CommonUnitMessages.minute)}`;
}
